import { connect } from "react-redux";
import NotComparedTable from "./NotComparedTable";
import { getProjectComparison } from "../../../../../../../../../../redux/actions";

const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchProjectNotComparedApi: state.BenchmarkFilteringReducer.fetchProjectNotComparedApi,
});

const mapDispatchToProps = (dispatch) => ({
    getProjectComparison: (payload) => dispatch(getProjectComparison(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotComparedTable);
